/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_Fee_Reason_LabelInputs */

const vi_sales_return_fee_reason_label = /** @type {(inputs: Sales_Return_Fee_Reason_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do thu phí`)
};

/**

* @param {Sales_Return_Fee_Reason_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_fee_reason_label = /** @type {((inputs?: Sales_Return_Fee_Reason_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Fee_Reason_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_fee_reason_label(inputs)
});